import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const SUB_PLANS = [
  { id: "solo", price: 11.99, compare: 16.99, picks: 1, label: "1 soin par mois", name: "Solo" },
  { id: "duo", price: 19.99, compare: 33.98, picks: 2, label: "2 soins par mois", name: "Duo" },
  { id: "reassort", price: null, compare: null, picks: null, label: "Tous vos produits à -10 %, tous les 1, 2 ou 3 mois", name: "Réassort" },
  { id: "famille", price: 39.9, compare: null, picks: 4, label: "4 soins par mois", name: "Famille", maxSave: 28.06,
    ship: { mondial_relay: 3.5, mondial_relay_eu: 3.5, colissimo_domtom: 11.9 } },
];
export const DUO = SUB_PLANS[1];
export const DUO_SAVE = Math.round((DUO.compare - DUO.price) * 100) / 100;
export const DUO_PCT = Math.round((1 - DUO.price / DUO.compare) * 100);
export const SUB_INTERVALS = [1, 2, 3];
export const every = (n) => (n === 1 ? "chaque mois" : `tous les ${n} mois`);
export const reassortPrice = (p) => Math.round(Number(p?.price || 0) * 90) / 100;
export const SUB_MAX_PRICE = 16.99;

/** L'Abonnement Extrême Repouss : flacon 50 ml chaque mois, 4,99 € + 3,50 € de livraison Point Relais (France et Europe). */
export const EXTREME = { slug: "extreme-repouss-voyage-50ml", price: 4.99, shipping: 3.5, total: 8.49, unit: 11.99, path: "/abonnement-extreme-repouss",
  image: "/products/real/extreme-voyage-50-studio.webp", photo: "/products/real/extreme-voyage-50-studio.webp" };
export const EXTREME_EU = "Belgique, Luxembourg, Pays-Bas, Espagne, Portugal, Allemagne, Autriche, Italie, Pologne";

export const isSubEligible = (p) => p?.type === "unite" && Number(p?.price) <= SUB_MAX_PRICE && p?.slug !== EXTREME.slug;

/** Offre de bienvenue abonnement : 1er mois Duo 16,99 €, Solo 9,99 € (nouvelles abonnées), activable depuis l'admin. */
export const FIRST_MONTH = { duo: 16.99, solo: 9.99 };
export function useFirstMonthOn() {
  const { data } = useSubOffer();
  return data?.first_month_on === true;
}

export function useSubOffer() {
  return useQuery({
    queryKey: ["sub-offer"],
    queryFn: async () => (await api.get("/subscriptions/offer")).data,
  });
}

export const SUB_STATUS = {
  active: "Actif",
  paused: "En pause",
  past_due: "Paiement à régulariser",
  canceled: "Arrêté",
};

export const frDate = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }) : "");
